export const sanitizeListRestProps = <T extends object = any>(
  props: T,
  injectedProps: (keyof Partial<T>)[]
) =>
  Object.keys(props)
    .filter((propName) => injectedProps.includes(propName as keyof T))
    .reduce((acc, key) => ({ ...acc, [key]: (props as any)[key] }), {}) as T;
